import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  technologies: [],

  technology: {},
  technologySaved: {},
  technologySelected: {},

  technologiesP: [],
  totalItemsTechnologyP: 0,
  totalPagesTechnologyP: 0,
  currentPageTechnologyP: 0,

  technologiesS: [],
  totalItemsTechnologyS: 0,
  totalPagesTechnologyS: 0,
  currentPageTechnologyS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberTechnologySelected: 0,

  isLoadingTechnologies: false,

};

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const technologyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TECHNOLOGY_START_REGISTER_ADMIN:

      return {
        ...state,
        technologySaved: action.payload,
      };

    case types.TECHNOLOGY_UPDATE:
      if (state.technologiesS.length > 0) {
        return {
          ...state,
          technologiesS: state.technologiesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          technologiesP: state.technologiesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          technologiesP: state.technologiesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.TECHNOLOGY_DELETE:
      if (state.technologiesS.length > 0) {
        return {
          ...state,
          technologiesS: state.technologiesS.filter((usr) => usr.id !== action.payload),
          technologiesP: state.technologiesP.filter((usr) => usr.id !== action.payload),
          technologySelected: {},
        };
      } else {
        return {
          ...state,
          technologiesP: state.technologiesP.filter((usr) => usr.id !== action.payload),
          technologySelected: {},
        };
      }

    case types.TECHNOLOGY_START_LOADING_PAGINATED:
      return {
        ...state,
        technologiesP: action.payload.technologysP,
        totalItemsTechnologyP: action.payload.totalItems,
        totalPagesTechnologyP: action.payload.totalPages,
        currentPageTechnologyP: action.payload.currentPage,
      };

    case types.TECHNOLOGY_START_LOADING_TECHNOLOGY_PAGINATED:

      return {
        ...state,
        technologiesS: action.payload.technologysP,
        totalItemsTechnologyS: action.payload.totalItems,
        totalPagesTechnologyS: action.payload.totalPages,
        currentPageTechnologyS: action.payload.currentPage,

      };

    case types.TECHNOLOGY_START_SEARCH_PAGINATED:
      return {
        ...state,
        technologiesS: action.payload.technologysP,
        totalItemsTechnologyS: action.payload.totalItems,
        totalPagesTechnologyS: action.payload.totalPages,
        currentPageTechnologyS: action.payload.currentPage,
      };

    case types.TECHNOLOGY_SELECT:
      return {
        ...state,
        technologySelected: action.payload,
      };

    case types.TECHNOLOGY_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        technologiesS: [],
        totalItemsTechnologyS: 0,
        totalPagesTechnologyS: 0,
        currentPageTechnologyS: 0,

        numberTechnologySelected: 0
      };

    case types.TECHNOLOGY_CLEAN_PAGINATED:
      return {
        ...state,
        technologiesP: [],
        totalItemsTechnologyP: 0,
        totalPagesTechnologyP: 0,
        currentPageTechnologyP: 0,

      };

    case types.TECHNOLOGY_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.TECHNOLOGY_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.TECHNOLOGY_CLEAN_SAVED:
      return {
        ...state,
        technologySaved: {},
      };

    /*
  case types.TECHNOLOGY_LIST_UPDATE_SELECTED:
    
    if (state.technologiesS.length > 0) {
      return {
        ...state,
        technologiesS: state.technologiesS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

      };
    }
    break;
    */
    case types.TECHNOLOGY_LIST_UPDATE_SELECTED: {
      const id = action.payload;
      const currentSelectedCount = countSelected(state.technologiesS);
      const targetItem = state.technologiesS.find(item => item.id === id);

      // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
      if (!targetItem.isSelected && currentSelectedCount >= 9) return state;

      const newTechnologies = state.technologiesS.map(item =>
        item.id === id ? { ...item, isSelected: !item.isSelected } : item
      );

      const newCount = countSelected(newTechnologies);

      return {
        ...state,
        technologiesS: newTechnologies,
        numberTechnologySelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Selección masiva (Primeros 9 o todos si hay menos)
    case types.TECHNOLOGY_SELECT_ALL_LIMIT: {
      const newTechnologies = state.technologiesS.map((item, index) => ({
        ...item,
        isSelected: index < 9 // Selecciona solo los primeros 9
      }));

      const newCount = countSelected(newTechnologies);

      return {
        ...state,
        technologiesS: newTechnologies,
        numberTechnologySelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Limpiar todo
    case types.TECHNOLOGY_CLEAN_ALL_SELECTED: {
      return {
        ...state,
        technologiesS: state.technologiesS.map(item => ({ ...item, isSelected: false })),
        numberTechnologySelected: 0,
        moreThanOneIsSelected: false
      };
    }

    //Clean Without list
    case types.TECHNOLOGY_CLEAN_ALL_WITHOUT_LIST: {
      return {
        ...state,
        numberTechnologySelected: 0,
        moreThanOneIsSelected: false
      };
    }

    case types.TECHNOLOGY_GET_MORE_THAN_ONE_SELECTED:

      debugLogReducer(":: TECHNOLOGY_GET_MORE_THAN_ONE_SELECTED");

      if (state.technologiesS.length > 0) {
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.TECHNOLOGY_LIST_SET_NUMBER_SELECTED:

      debugLogReducer(":: TECHNOLOGY_LIST_SET_NUMBER_SELECTED");

      if (state.technologiesS.length > 0) {
        return {
          ...state,
          numberTechnologySelected: action.payload
        };
      }
      break;

    case types.TECHNOLOGY_CLEAN_SEARCH_INFORMATION:

      debugLogReducer(":: TECHNOLOGY_CLEAN_SEARCH_INFORMATION");

      return {
        ...state,
        numberTechnologySelected: 0
      };

    case types.TECHNOLOGY_IS_LOADING:
      //console.count("--⏱️ TECHNOLOGY_LOADING_START");

      return {
        ...state,
        isLoadingTechnologies: true
      };

    case types.TECHNOLOGY_IS_LOADING_FINISH:
      return {
        ...state,
        isLoadingTechnologies: false
      };

    case types.AUTH_LOGOUT:
      return {
        ...state,
        isLoadingTechnologies: false
      };

    case types.TECHNOLOGY_CLEAN_NUMBER_OF_SELECTED:

      if (state.technologiesS.length > 0) {
        return {
          ...state,
          technologiesS: state.technologiesS.map((usr) =>
            usr.isSelected ? { ...usr, isSelected: false } : usr
          ),

        };
      }
      break;

    case types.TECHNOLOGY_CLEAN_NUMBER_OF_COMPARED:

      if (state.technologiesS.length > 0) {
        return {
          ...state,
          technologiesS: state.technologiesS.map((usr) => ({ ...usr, isCompared: false })),
        };
      }
      break;

    case types.TECHNOLOGY_CLEAN_NUMBER_OF_SELECTED_COMPARED:

      if (state.technologiesS.length > 0) {
        return {
          ...state,
          technologiesS: state.technologiesS.map((usr) => ({
            ...usr,
            isSelected: false,
            isCompared: false
          })),

        };
      }
      break;



    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {

  debugLogReducer(":: getMoreThanOneIsSelected");


  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.technologiesS.length > 0) {
    state.technologiesS.forEach(element => {

      if (element.isSelected) {
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}